/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system'
import { Message } from '@prom/web-embers'

export const StyledMessage = styled(Message)({
  marginBottom: 16,
})
